var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.729,46.691C78.171,46.046,64.857,30.879,48,30.879c-16.857,0-30.171,15.167-30.73,15.812L16.138,48l1.132,1.309 C17.829,49.954,31.143,65.121,48,65.121c16.857,0,30.171-15.167,30.729-15.812L79.861,48L78.729,46.691z M48,61.121 c-12.28,0-22.93-9.564-26.464-13.121C25.07,44.444,35.72,34.879,48,34.879c12.281,0,22.93,9.565,26.464,13.121 C70.93,51.556,60.281,61.121,48,61.121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.246,48c0,5.93,4.824,10.754,10.754,10.754S58.754,53.93,58.754,48S53.93,37.246,48,37.246S37.246,42.07,37.246,48z  M54.754,48c0,3.724-3.03,6.754-6.754,6.754c-3.724,0-6.754-3.03-6.754-6.754c0-3.724,3.03-6.754,6.754-6.754 C51.724,41.246,54.754,44.276,54.754,48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.ba4247827f0fa7059697f7c7faf16aa1.svg";
export { ForwardRef as ReactComponent };